<div class="d-flex justify-content-center mb-3">
    <mat-form-field appearance="fill" class="me-2">
        <mat-label class="form-label">Start dátum és idő</mat-label>
        <input readonly="true" matInput [matDatepicker]="startPicker" [(ngModel)]="date"
            (ngModelChange)="updateDate($event)" placeholder="yyyy. mm. dd." />
        <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
        <mat-datepicker [startAt]="today" #startPicker></mat-datepicker>
    </mat-form-field>
    <ngb-timepicker [(ngModel)]="time" (ngModelChange)="validateTime($event)" seconds="true"
        class="time-picker-custom"></ngb-timepicker>
</div>